<script setup>

import { defineProps, defineEmits, ref, watch} from "vue";
import BarraNavegacao from "./BarraNavegacao.vue";
import FollowUpConteudo from "./FollowUpConteudo.vue";
import { DateTime } from "luxon";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "criandoFollowUp",
    "controlesDesativados",
    "pedidoDeCompra"
]);

const emits = defineEmits([
    "update:criandoFollowUp",
    "update:controlesDesativados"
]);

//==================================================================//
//===================== Altera Criando Pedido ======================//
//==================================================================//

const followUp = ref({
    observacao: "",
    dataEntrega: "",
});

//==================================================================//
//===================== Altera Criando Pedido ======================//
//==================================================================//

const alteraCriandoFollowUp = (update) =>{

    emits('update:criandoFollowUp',update);

};

//==================================================================//
//===================== Altera Criando Pedido ======================//
//==================================================================//

const alteraControlesDesativados = (update) =>{

    emits('update:controlesDesativados',update);

};

//==================================================================//
//========================= Altera FollowUp ===========================//
//==================================================================//

const alteraFollowUp = (update) =>{

    followUp.value = {
        ...followUp.value,
        ...update
    }
}

//==================================================================//
//========================= Altera FollowUp ========================//
//==================================================================//

const preencheComFollowUpPadrao = () =>{

    let dataEntrega = DateTime.now().startOf("day");
    dataEntrega = dataEntrega.toFormat("yyyy-MM-dd");

    alteraFollowUp({
        observacao: "",
        dataEntrega: dataEntrega,
    });

}

//==================================================================//
//============================= Watch ==============================//
//==================================================================//

watch(()=> props.criandoFollowUp, () => {

    preencheComFollowUpPadrao();

});

</script>

<template>

    <main>

        <v-dialog
            content-class="c-dialog"
            v-model="props.criandoFollowUp"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card
                class="c-modal"
                :class="{ 'c-modal--disabled': props.controlesDesativados }"
            >

                <BarraNavegacao
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :controlesDesativados="props.controlesDesativados"
                    :pedidoDeCompra="props.pedidoDeCompra"
                    :followUp="followUp"
                    :criandoFollowUp="props.criandoFollowUp"
                    @update:criandoFollowUp="alteraCriandoFollowUp"
                    @update:controlesDesativados="alteraControlesDesativados"
                >
                </BarraNavegacao>

                <FollowUpConteudo
                    :pedidoDeCompra="pedidoDeCompra"
                    :followUp="followUp"
                    :controlesDesativados="controlesDesativados"
                    @update:followUp="alteraFollowUp"
                >
                </FollowUpConteudo>
            
            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

.c-modal--disabled{
    pointer-events: none;
    user-select: none; 
}

</style>

